import styles from "./part6.module.scss";

export default function HomePart2() {
  const listArr = [
    {
      pic: "/img/icon_user.png",
      title: "100M",
      desc: "Users in 2019",
    },
    {
      pic: "/img/icon_stars.png",
      title: "610K+",
      desc: "5 star ratings",
    },
    {
      pic: "/img/icon_best.png",
      title: "300M",
      desc: "Best Free Calling App voters",
    },
    {
      pic: "/img/icon_yearlyminutes.png",
      title: "1,000M",
      desc: "Yearly minutes",
    },
    {
      pic: "/img/icon_messages.png",
      title: "200M",
      desc: "Yearly messages",
    },
    {
      pic: "/img/icon_numbers.png",
      title: "1,000K+",
      desc: "Available numbers",
    },
  ];
  return (
    <div className={styles.block + " main"}>
      <div className={styles.top}>
        <h2>Best App for Calls, Texts & Numbers</h2>
        <p>
          Released in <span>2012</span>
        </p>
      </div>
      <div className={styles.inner + " flex-r"}>
        {listArr.map((item, index) => (
          <div className={styles.item} key={index}>
            <div className={styles.img}>
              <img src={item.pic} alt={item.title+' '+item.desc} />
            </div>
            <h3>{item.title}</h3>
            <p>{item.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
